module.exports = __webpack_public_path__ + "static/media/28PerformancePhotos.00280ba6.jpeg";